import React from 'react';
import { getInstoreOrderAddress } from 'shared/helpers/orders';
import styled from 'styled-components';

import { Typography } from 'src/typography';
import type { PosOrderFieldsFragment } from 'src/gql/graphql';

type InstoreReceiptHeaderProps = {
  locationDetails: PosOrderFieldsFragment['locationDetails'];
};

export function InstoreReceiptHeader({ locationDetails }: InstoreReceiptHeaderProps): JSX.Element {
  const address = getInstoreOrderAddress(locationDetails);

  return (
    <Header>
      <Typography.Heading tag='h2' size='small'>
        {locationDetails.name}
      </Typography.Heading>
      {!!address && (
        <Typography.Body tag='p' size='small'>
          {address}
        </Typography.Body>
      )}
    </Header>
  );
}

const Header = styled.div`
  text-align: left;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  color: ${({ theme }) => theme.colors.grey[30]};
  margin-bottom: 30px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-bottom: 0;
  }
`;
